import { useCallback, useEffect, useState } from "react";

/**
 * Tiny fullscreen hook tied to a wrapper ref. Exposes the current state and a
 * toggle. Used by the deck so the F key + the top-right utility button stay in
 * sync with the browser's actual fullscreen state.
 */
export function useFullscreen(wrapRef) {
  const [isFull, setIsFull] = useState(false);

  useEffect(() => {
    const onFs = () => setIsFull(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", onFs);
    return () => document.removeEventListener("fullscreenchange", onFs);
  }, []);

  const toggle = useCallback(async () => {
    if (!document.fullscreenElement) {
      try { await wrapRef.current?.requestFullscreen(); } catch { /* ignore */ }
    } else {
      try { await document.exitFullscreen(); } catch { /* ignore */ }
    }
  }, [wrapRef]);

  return { isFull, toggle };
}
